import { RouteMapping } from './route-mapping.js';
const cmsRoutes = {
    IndexPage: {
        path: '/',
        pageName: 'IndexPage',
        component: 'IndexPageScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    ToolkitConfigsPage: {
        path: '/toolkits',
        pageName: 'ToolkitConfigsPage',
        component: 'ToolkitConfigsScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    CreateMbaToolkitPage: {
        path: '/toolkits/create/mba',
        pageName: 'CreateMbaToolkitPage',
        component: 'CreateMbaToolkitScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: ['isEmbeddable'],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    Auth0InvitesPage: {
        path: '/toolkits/:id/invite-admins',
        pageName: 'Auth0InvitesPage',
        component: 'Auth0InvitesScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: ['id'],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    WebhookManagerPage: {
        path: '/toolkits/:id/webhooks',
        pageName: 'WebhookManagerPage',
        component: 'WebhookManagerScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: ['id'],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    LogsPage: {
        path: '/toolkits/:id/logs',
        pageName: 'LogsPage',
        component: 'LogsScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: ['id'],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    UpdateMbaToolkitPage: {
        path: '/toolkits/mba/:id',
        pageName: 'UpdateMbaToolkitPage',
        component: 'UpdateMbaToolkitScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: ['id'],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    SettingsPage: {
        path: '/settings',
        pageName: 'SettingsPage',
        component: 'SettingsScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    }
};
export class CmsRouteMapping extends RouteMapping {
    constructor() {
        super(cmsRoutes);
    }
}
//# sourceMappingURL=cms.js.map